import { render, staticRenderFns } from "./ConfirmDxPopup.vue?vue&type=template&id=116e6749&scoped=true"
import script from "./ConfirmDxPopup.vue?vue&type=script&lang=js"
export * from "./ConfirmDxPopup.vue?vue&type=script&lang=js"
import style0 from "./ConfirmDxPopup.vue?vue&type=style&index=0&id=116e6749&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116e6749",
  null
  
)

export default component.exports